import { cn } from '@repo/tailwind-config/tailwind.functions'

type Props = {
  className?: string
}

const DottedLine = ({ className }: Props) => {
  return (
    <div
      aria-hidden="true"
      role="separator"
      className={cn('w-full rounded-lg', className)}
      style={{
        backgroundImage: 'linear-gradient(to right, #CBD5E0 50%, rgba(255,255,255,0) 0%)',
        backgroundSize: '8px',
        backgroundRepeat: 'repeat-x',
        height: '2px'
      }}
    />
  )
}

export default DottedLine
